export const parseUrlQuery = (url: URLSearchParams): Record<string, string | number> => {
	const urlObject: Record<string, string | number> = {};

	url.forEach((value, key) => {
	    urlObject[key] = isNaN(+value) ? value : +value;
	});

	return urlObject;
};
